export default __webpack_public_path__ + "static/img-ef-6-8f3c3e4120a975f219b477ca30bc2e1d.png";